import { Component, OnInit } from '@angular/core';
import { DataAnalyticsService } from '../../data-analytics/data-analytics.service';
import { EnergyDataService } from '../../energy-data/energy-data.service';
import { HttpService } from '../../services/http.service';
import { LdsUserService } from '../../services/lds-user.service';
import { LdsEventBusService } from '../../services/lds-event-bus.service';
import { ActivatedRoute } from '@angular/router';
import { DataExportService } from '../../services/data-export.service';
import { PopupComponent } from '../../common-components/popup/popup.component';
import { OctopusService } from '../../services/octopus-service.service';
import { time } from '../../services/global-variables.service';
import { TimeSelectComponent } from '../../time-select/time-select.component';
import { MatDialog } from '@angular/material/dialog';
import { DateTime } from 'luxon'
import { map } from 'rxjs';

@Component({
    selector: 'lds-energy-monitor',
    templateUrl: './energy-monitor.component.html',
    styleUrls: ['./energy-monitor.component.scss'],
    standalone: false
})
export class EnergyMonitorComponent implements OnInit {

  private count = 0;
  public timespan;
  public hasNoData = true;
  public featureSet;
  public featuresToShow;
  public deviceType;
  public features;
  public data;
  public energyMonitors;
  public octopusData;
  public startTime;
  public endTime;
  // public isOctopus: boolean;

  constructor(private route: ActivatedRoute,
    public user: LdsUserService,
    private dataAnalytics: DataAnalyticsService,
    private http: HttpService,
    private eventBus: LdsEventBusService,
    private energyData: EnergyDataService,
    private popup: PopupComponent,
    private dialog: MatDialog,
    private dataExport: DataExportService,
    private octopus: OctopusService
  ) { }
  ngOnDestroy() {
    this.data = undefined;
    this.deviceType = undefined;
    this.featureSet = undefined;
    this.timespan = undefined;
    this.features = undefined;
  }
  ngAfterViewInit(): void {
    this.showGraph(this.featureSet);
  }

  async ngOnInit() {
    // this.isOctopus = false;
    this.route.params.pipe(map(params => params['id'])).subscribe((id) => {
      this.timespan = 'weekly';
      this.featureSet = this.user.energyMonitors[id];
      this.user.currentModule = 'Energy Monitor - ' + this.featureSet.name;
      this.energyMonitorSwitch();
    });
  }


  private energyMonitorSwitch() {
    this.deviceType = 'energy';
    this.showGraph(this.featureSet);
  }


  private async showGraph(featureSet, timespan?) {
    if(!timespan){
      timespan = 'weekly';
    }
    this.timespan = timespan;
    let date = new Date();
      switch (timespan) {
        case 'weekly':
          this.startTime = date.getTime() - time.day * 6
          this.startTime = DateTime.fromMillis(this.startTime).startOf('day').toMillis() + time.hour;
          this.endTime = date.getTime();
          this.loadData(featureSet);
          break;
        case 'monthly':
          this.startTime = date.getTime() - time.day * 30;
          this.startTime = DateTime.fromMillis(this.startTime).startOf('day').toMillis() + time.hour;
          this.endTime = date.getTime();
          this.loadData(featureSet);
          break;
        case "custom":
          this.dialog.open(TimeSelectComponent).afterClosed().subscribe((res: any) => {
            if (!res.timeSelected) {
              return;
            }
            this.startTime = res.startDate.getTime();
            this.endTime = res.endDate.getTime();
            this.timespan = timespan;
            this.loadData(featureSet);
            return;
          });
      
        }
      
  
    }

    async loadData(featureSet){
      let localFeatures = [];
      let energyFeature;
      for (let i in featureSet.features) {
        let feature = this.user.features[featureSet.features[i]];
        if (feature.attributes.type === 'power' || feature.attributes.type === 'energy') {
          localFeatures.push(feature);
          if(feature.attributes.type === 'energy'){
            energyFeature = feature;
          }
        }
      }


     this.data = await this.dataAnalytics.getPagedData(null, energyFeature.featureId, 7, this.startTime, this.endTime, "energy");
     

     if(this.data[this.data.length-1].timestamp === this.data[this.data.length-2].timestamp){
      delete this.data[this.data.length-1];
     }
        if(this.data){
          this.features = localFeatures;
          this.featureSet = featureSet;
          this.deviceType = 'energy';
          this.hasNoData = false;
          this.user.loading = false;
        }
    }

    changeTimeSpan(timespan) {
      this.showGraph(this.featureSet, timespan);
    }

    onExportClick(){
      this.popup.open().afterClosed().subscribe(res => {
        this.dataExport.exportData(this.featureSet, this.data, true, this.timespan);
      });
    }

  }
